<div class="p-7 bg-lightest">
  <div class="flex md:inline">
    <div
      class="md:ml-10 md:inline"
      *ngIf="hasToken">
      <button
        pButton
        class="back-accueil font-app-medium">
        <i class="pi pi-arrow-left mr-4 text-lg"></i>
        <span class="md:inline hidden">{{ "paymentRequest.backButton" | translate }}</span>
      </button>
    </div>
    <div class="title">
      <h1
        [ngClass]="{ 'ml-[40px]': !hasToken, 'ml-[20px]': hasToken }"
        class="flex flex-row text-xl md:text-2xl font-app-bold mb-5 md:mb-10 md:ml-10 md:mt-5">
        {{ "paymentRequest.title" | translate }}
      </h1>
    </div>
  </div>
  <div
    class="card mx-auto w-full md:mb-40"
    *ngIf="!showPopupPayment; else popupPaymentEvent">
    <p-card>
      <ng-template
        pTemplate="header"
        class="card-header">
        <p class="font-app-black text-sm text-darkest">{{ "paymentRequest.text1" | translate }} {{ name }}</p>
        <p class="font-app-regular text-sm mt-5 text-darkest">
          {{ "paymentRequest.text2" | translate }}
          {{ productName }}
          {{ "paymentRequest.text3" | translate }}
          {{ numeroContrat }}
          {{ "paymentRequest.text4" | translate }}
        </p>
        <p class="flex justify-center mt-2 text-primary text-2xl font-app-bold">
          {{ amount | currency: "EUR" : "symbol" : "" : "fr" }}
        </p>
        <p class="font-app-regular text-sm mt-5 text-darkest">
          {{ "paymentRequest.detailAmount" | translate }}
        </p>
        <div>
          <ul>
            @for (receipt of receiptDetails; track receipt) {
              <li class="font-app-regular text-sm text-darkest ml-3">
                {{ "paymentRequest.receipt" | translate }}
                {{ receipt.coverDate | date: "MMMM y" : "Europe/Paris" : "fr" }}
                : {{ receipt.amount | currency: "EUR" : "symbol" : "" : "fr" }}
              </li>
            }
          </ul>
        </div>
      </ng-template>
      <p-divider
        type="solid"
        class="-mt-4"></p-divider>
      <ng-template pTemplate="content">
        <p class="font-app-black text-sm text-darkest">
          {{ "paymentForm.title" | translate }}
        </p>
        <br />
        <app-payment-form
          *ngIf="formToken"
          (paymentEvent)="paymentEvent($event)"
          (showPopup)="showPopup($event)"
          [formToken]="formToken"></app-payment-form>
      </ng-template>
    </p-card>
  </div>
</div>
<ng-template #popupPaymentEvent>
  <app-popup-events-payment
    *ngIf="showPopupPayment === true"
    [paymentSuccess]="paymentSuccess"
    [showPopupPayment]="showPopupPayment"
    [unpaidPolicy]="hasUnpaidReceipts"
    [advancePayment]="!hasUnpaidReceipts"></app-popup-events-payment>
</ng-template>

